import './index.css';
import Header from '../../components/Navigation/Header';
import { useState } from 'react';
import {ChangePasswordService} from '../../services/auth';

import Cookies from 'js-cookie';

function ChangePassword()
{

    const [error,setError]=useState();

    const handleSubmit=async (e)=>{
        e.preventDefault();
        
        const form=new FormData(e.target);
        
        form.append('userid',Cookies.get('id'));

        const obj=Object.fromEntries(form.entries());
        
        console.log(obj);
        if(!obj.oldPassword || !obj.newPassword || !obj.confirmPassword)
            return setError('Field cannot be empty !');
        console.log(obj.newPassword,obj.confirmPassword)
         if(obj.newPassword!==obj.confirmPassword)
            return setError('Passwords must match');

         setError('');

        const response=await ChangePasswordService(obj);
        if(response.success)
        {
            console.log(response);
            return setError(response.message);
        } 
        return setError(response);
    }
return(<>
              <Header/>
              <div className='profilesetupcontainer'>
                <div className='profilesubcontainer'>
                <div className='profileheadline'>
                    <h2>Change Password</h2>
                    <h3>Strong Password required. Combine uppercase letters, lowercase letters and symbols </h3>
                </div>
                <form className='mainprofileform' onSubmit={(e)=>handleSubmit(e)}>
                    <div className='profileform'>
                        <section className='changepassword'>
                            {/* <span>
                                <h2>Password</h2>
                             </span> */}
                            <span>
                                <label>Old Password:</label>
                                <input type='password' id='oldpassword' name='oldPassword'  />
                             </span>
                             <span>
                                <label>New Password:</label>
                                <input type='password'  id='newpassword' name='newPassword'  />
                             </span>
                             <span>
                                <label>Confirm Password:</label>
                                <input type='text' id='confirmpassword' name='confirmPassword'/>
                             </span>
                             <span>
                                <label>{error}</label>
                             </span>
                        </section>
                    </div>
                    <div className='profilesubmitbutton'>
                     <label></label>
                      <button type='Submit'>SUBMIT</button>
                    </div>
                </form>
              </div>
              </div>
        </>)
}


export default ChangePassword;